import React from 'react';
import { FormControl, InputLabel, OutlinedInput, Select } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from "@mui/material";
import { tokens } from '../theme';
import { SelectLabel } from './Styles';


const MuiSelect = ({ list = [],
    label, selectdValue, onChange, disabled, noneText, required, multiple = false }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <FormControl fullWidth sx={SelectLabel(colors)} >
            <InputLabel required={required} id="demo-simple-select-label-client">
                {label}
            </InputLabel>
            <Select
                sx={{ bgcolor: colors.grey[70] }}
                labelId="demo-simple-select-label-client"
                id="demo-simple-select-client"
                input={<OutlinedInput label={label} />}
                required={required}
                disabled={disabled}
                value={multiple ? (selectdValue || []) : (selectdValue || "")}
                onChange={onChange}
                multiple={multiple}
                fullWidth>
                {
                    list.length ? (
                        list.map((item, index) => (
                            <MenuItem key={`${item.id}-${index}`} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))
                    ) : (
                        <MenuItem key="no-client" value={-1}>
                            {noneText}
                        </MenuItem>
                    )
                }
            </Select>
        </FormControl>
    )
}
export default MuiSelect;